/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import classNames from 'classnames'
import { useIntl } from 'react-intl'
import { ContactDetailsType, IContactDto } from '../Contact.model'
import { Link } from 'react-router-dom'

interface Props {
  disabled?: boolean
  data: IContactDto
  rowSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  onRowClick?: (id: string) => void
  removeOnClick?: (id: string) => void
}

export const ContactListItem: FC<Props> = ({
  disabled,
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  onRowClick,
  removeOnClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected
  
  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected
  
  const buildDescriptionLine = (contact: IContactDto): string => {
    let description = ''
    if (contact.email && contact.telephone) {
      description += `${contact.email} | ${contact.telephone}`
    } else if (contact.email) {
      description += `${contact.email}`
    } else if (contact.telephone) {
      description += `${contact.telephone}`
    }

    if (!description && contact.details) {
      const emails = contact.details.filter((detail) => detail.type === ContactDetailsType.EMAIL)
      const telephones = contact.details.filter(
        (detail) => detail.type === ContactDetailsType.TELEPHONE
      )
      if (emails && emails.length > 0 && telephones && telephones.length > 0) {
        const email: string = emails[0].value ?? ''
        const telephone: string = telephones[0].value ?? ''
        description += `${email} | ${telephone}`
      } else if (emails && emails.length > 0) {
        description += `${emails[0].value ?? ''}`
      } else if (telephones && telephones.length > 0) {
        description += `${telephones[0].value ?? ''}`
      }
    }

    if (contact.address && contact.countryCode) {
      return (description += description
        ? ` | ${contact.address} | ${intl.formatMessage({
            id: `DROPDOWN.COUNTRY.${contact.countryCode}`,
          })}`
        : `${contact.address} | ${intl.formatMessage({
            id: `DROPDOWN.COUNTRY.${contact.countryCode}`,
          })}`)
    } else if (contact.address) {
      return (description += description ? ` | ${contact.address}` : `${contact.address}`)
    } else if (contact.countryCode) {
      return (description += description
        ? ` | ${intl.formatMessage({id: `DROPDOWN.COUNTRY.${contact.countryCode}`})}`
        : `${intl.formatMessage({id: `DROPDOWN.COUNTRY.${contact.countryCode}`})}`)
    }
    return description.toUpperCase()
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex flex-stack'>
        <div className='d-flex align-items-center'>
          {!disabled && removeOnClick && (
            <div className='row'>
              <div className='d-flex justify-content-end align-items-center'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon'
                  onClick={() => removeOnClick(data.id)}
                >
                  <i className='bi bi-x fs-1 fw-bold text-danger'></i>
                </button>
              </div>
            </div>
          )}

          <div>
            <div className='d-flex flex-stack'>
              <div className='d-flex align-items-center'>
                <div className='symbol symbol-35px symbol-circle mx-2'>
                  <span className='symbol-label bg-secondary text-light-secondary fs-6 fw-bolder'>
                    {data.displayName.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div>
                  <div className='lh-2 fs-7'>
                    <span className='fw-bolder'>{data.displayName}</span>
                  </div>
                  <div className='text-gray-600 fs-8'>{buildDescriptionLine(data)}</div>
                </div>
              </div>
            </div>

            {/* <div className='mt-1 lh-1'>
              <div className='d-flex justify-content-start align-items-center'>
                <IconLabelContent
                  title={`${intl
                    .formatMessage({id: 'TITLE.CONTRACT.TOTAL'})
                    .replace(/%s/g, `${data.totalContract > 0 ? data.totalContract : 0}`)}`}
                  labelValue={`${data.totalContract || ''}`}
                  active={data.totalContract > 0}
                  icon='bi bi-vector-pen'
                />

                <IconLabelContent
                  title={`${intl
                    .formatMessage({id: 'TITLE.ASSET.TOTAL'})
                    .replace(/%s/g, `${data.totalAsset > 0 ? data.totalAsset : 0}`)}`}
                  labelValue={`${data.totalAsset || ''}`}
                  active={data.totalAsset > 0}
                  icon='bi bi-cpu'
                />

                <IconLabelContent
                  title={`${intl
                    .formatMessage({id: 'TITLE.REPORT.TOTAL'})
                    .replace(/%s/g, `${data.totalReport > 0 ? data.totalReport : 0}`)}`}
                  labelValue={`${data.totalReport || ''}`}
                  active={data.totalReport > 0}
                  icon='bi bi-speedometer'
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
